import { onRouteChange } from './router';
import { state } from './state';

// Идентификатор посетителя в localStorage: считаем уникальных без cookie.
const STORAGE_VISITOR = 'visit.visitor_id';

// Служебные разделы не учитываем (их же отсекает сервер).
const EXCLUDED = new Set(['/admin', '/control', '/overlay']);

// Локальная разработка в статистику не попадает (сервер отсекает по Host/IP).
function isDevHost(): boolean {
    const host = location.hostname.toLowerCase();
    return (
        host === 'localhost' ||
        host === '127.0.0.1' ||
        host === '0.0.0.0' ||
        host === '::1' ||
        host === '[::1]' ||
        host.endsWith('.local')
    );
}

function visitorId(): string {
    let id = localStorage.getItem(STORAGE_VISITOR);
    if (!id) {
        id = typeof crypto.randomUUID === 'function'
            ? crypto.randomUUID()
            : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
        localStorage.setItem(STORAGE_VISITOR, id);
    }
    return id;
}

let firstTrack = true;

async function sendVisit(pathname: string, referrer: string): Promise<void> {
    try {
        await fetch('/api/visits', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...(state.token ? { Authorization: `Bearer ${state.token}` } : {}),
            },
            body: JSON.stringify({
                path: pathname,
                referrer: referrer || null,
                visitor_id: visitorId(),
            }),
            keepalive: true,
        });
    } catch {
        // Статистика не должна ломать навигацию.
    }
}

/** Пишет просмотр на каждый SPA-переход (включая первый). */
export function initVisitTracking(): void {
    if (isDevHost()) return;
    onRouteChange((pathname) => {
        if (EXCLUDED.has(pathname)) return;
        const referrer = firstTrack ? document.referrer : '';
        firstTrack = false;
        void sendVisit(pathname, referrer);
    });
}
